// BrandRoutes.tsx
import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import BrandHome from "../Home/BrandHome";
import { BrandLogin } from "../Login/BrandLogin";
import { BrandOtpVerify } from "../OtpVerification/BrandOtpVerify";
// import { BrandProfile2 } from "../Profile2/BrandProfile2";
import { BrandSignUp } from "../SignUp/BrandSignUp";
import { BrandWelcome } from "../Welcome/BrandWelcome";
import ProtectedRoute from "../../../Helpers/ProtectedRoute";
import { useAuth } from "../../../Providers/Auth";
import { PricingCheckOut } from "../Pricing/PricingCheckOut";
import { CheckOutSuccess } from "../Pricing/CheckOutSuccess";
// import { UpdateContact } from "../UpdateContact/UpdateContact";
// import { UpdateContactVerify } from "../UpdateContact/UpdateContactVerify";
import BrandPricingV2 from "../Pricing/PricingV2/PricingV2";
// import { CollabRatingForm } from "../VerifyCollab/CollabRatingForm";

const BrandRoutes: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const authState = useAuth();
  useEffect(() => {
    if (
      localStorage.getItem("jwtToken") &&
      localStorage.getItem("UserType") === "Brand" &&
      !authState?.loggedBrand
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [authState?.loggedBrand]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <Routes>
      {!localStorage.getItem("jwtToken") ||
      localStorage.getItem("UserType") === "Influencer" ? (
        <>
          <Route path="/*" element={<BrandSignUp />} />
          <Route path="/SignUp" element={<BrandSignUp />} />
          <Route path="/Login" element={<BrandLogin />} />
          <Route path="/Otp-verify" element={<BrandOtpVerify />} />
        </>
      ) : (
        <>
          <Route
            path="/Welcome"
            element={
              <ProtectedRoute
                navigateCondition={
                  !authState?.loggedBrand?.firstTime &&
                  authState?.loggedBrand?.isVerified &&
                  authState?.loggedBrand?.allBrandInfoFilled
                }
                toUrl={"/Brand/DashBoard"}
              >
                <BrandWelcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile2"
            element={
              <ProtectedRoute
                navigateCondition={
                  !authState?.loggedBrand?.firstTime &&
                  authState?.loggedBrand?.isVerified &&
                  authState?.loggedBrand?.allBrandInfoFilled
                }
                toUrl={"/Brand/DashBoard"}
              >
                <BrandWelcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/updateContact"
            element={
              <ProtectedRoute
                navigateCondition={
                  !authState?.loggedBrand?.firstTime &&
                  authState?.loggedBrand?.isVerified &&
                  authState?.loggedBrand?.allBrandInfoFilled
                }
                toUrl={"/Brand/DashBoard"}
              >
                <BrandWelcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/updateContact/otp-verify"
            element={
              <ProtectedRoute
                navigateCondition={
                  !authState?.loggedBrand?.firstTime &&
                  authState?.loggedBrand?.isVerified &&
                  authState?.loggedBrand?.allBrandInfoFilled
                }
                toUrl={"/Brand/DashBoard"}
              >
                <BrandWelcome />
              </ProtectedRoute>
            }
          />
          <Route path="/pricing" element={<BrandPricingV2 />} />
          <Route path="/pricing/checkout" element={<PricingCheckOut />} />
          <Route
            path="/pricing/checkout/success"
            element={<CheckOutSuccess />}
          />

          <Route
            path="/*"
            element={
              <ProtectedRoute
                navigateCondition={
                  authState?.loggedBrand?.firstTime ||
                  !authState?.loggedBrand?.isVerified ||
                  !authState?.loggedBrand?.allBrandInfoFilled
                }
                toUrl={"/Brand/Welcome"}
              >
                <BrandHome />
              </ProtectedRoute>
            }
          />
        </>
      )}
    </Routes>
  );
};

const Loader: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-4 border-t-blue-500 border-r-transparent border-b-blue-500 border-l-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-lg font-medium text-gray-700">Loading...</p>
      </div>
    </div>
  );
};

export default BrandRoutes;
